export enum WebSocketMessageType {
  WsHandleBackup,
  WsCreateBackupResponce,
  WsRestoreBackupResponce,
  WsPublishCommand,
  WsPublishStatus,
}